<template>
	<div>
		<div class="signin">
			<p class="title">用户登录</p>
			<el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick">
				<el-tab-pane label="账号密码登录" name="pwd">
					<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">

						<el-form-item label="" prop="accountNumber">
							<el-input v-model="ruleForm.accountNumber" placeholder="请输入手机号" ref="atlas-name-input"></el-input>
						</el-form-item>

						<el-form-item label="" prop="pass">
							<el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"></el-input>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%;" class="signinbtn">登录进入直播间</el-button>
							<el-link type="primary" :underline="false" @click="register">没有账号？点击注册</el-link>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="手机验证码登录" name="code">
					<el-form :model="coderuleForm" status-icon :rules="coderules" ref="coderuleForm" class="demo-ruleForm">
						<el-form-item label="" prop="accountNumber">
							<el-input v-model="coderuleForm.accountNumber" placeholder="请输入手机号"></el-input>
						</el-form-item>
						<el-form-item label="" prop="code">
							<el-input placeholder="请输入验证码" v-model="coderuleForm.code" autocomplete="off" class="input-with-select">
								<el-button slot="append" @click="sendSms('coderuleForm')" :disabled="!show">
									<span v-show="show">获取验证码</span>
									<span v-show="!show" class="count">{{count}} s</span>
								</el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="loginCode('coderuleForm')" style="width: 100%;" class="signinbtn">登录进入直播间</el-button>
							<el-link type="primary" :underline="false" @click="register">没有账号？点击注册</el-link>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
			<div class="flex">
			</div>
		</div>
	</div>
</template>

<script>
	import logocom from '@/components/logo/logo.vue';
	export default {
		data() {
			var accountNumber = (rule, value, callback) => {
				let mobilePhone = /^1[3|4|5|7|8|9][0-9]{9}$/;
				let email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
				if (!value) {
					return callback(new Error('账号不能为空'));
				}
				setTimeout(() => {
					if (mobilePhone.test(value)) {
						callback();
					} else {
						callback(new Error('请输入有效值'));
					}
				}, 500);
			};

			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			var valiCode = (rule, value, callback) => {
				console.log(value)
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else if (value.length != 6) {
					callback(new Error('验证码6位数'));
				} else {
					callback();
				}
			};
			return {
				show: true,
				count: "", // 初始化次数
				timer: null,
				activeName: 'pwd',
				remember: '',
				isonlineR: '',
				isteamR: '',

				ruleForm: {
					pass: '',
					accountNumber: ''
				},
				coderuleForm: {
					code: '',
					accountNumber: ''
				},
				rules: {
					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					accountNumber: [{
						validator: accountNumber,
						trigger: 'blur'
					}]
				},
				coderules: {
					accountNumber: [{
						validator: accountNumber,
						trigger: 'blur'
					}],
					code: [{
						validator: valiCode,
						trigger: 'blur'
					}]
				}
			};
		},
		mounted() {
			if (localStorage.getItem('user')) {
				this.$emit("loginOk",true);
			}
		},
		components: {
			logocom
		},
		methods: {
			handleClick(tab, event) {
				if (tab.name == 'pwd') {
					this.ruleForm.accountNumber = this.coderuleForm.accountNumber
				} else {
					this.coderuleForm.accountNumber = this.ruleForm.accountNumber
				}
			},
			loginCode(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let cnt = {
							phone: this.coderuleForm.accountNumber, // String 手机
							code: this.coderuleForm.code, // String <选填> 密码
						}
						this.$api.loginByCode(cnt, res => {
							if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
								this.$message.success('登录成功')
								localStorage.setItem("user", res.data.c);
								let info = JSON.parse(localStorage.getItem("user"))
								this.$emit("loginOk",true);
							} else {
								this.$message.error(res.data.rm);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			sendSms(formName) {
				this.$refs[formName].validateField('accountNumber', valid => {
					if (!valid) {
						this.codeSetTime()
						this.$api.sendSms({
							phone: this.coderuleForm.accountNumber
						}, res => {
							if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
								this.$message.success(res.data.c)
							} else {
								this.show = true;
								clearInterval(this.timer); // 清除定时器
								this.timer = null;
								this.$message.error(res.data.rm);
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			codeSetTime() {
				const TIME_COUNT = 60; //更改倒计时时间
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer); // 清除定时器
							this.timer = null;
						}
					}, 1000);
				}
			},
			// 判断是否是微信端浏览器
			isWeiXin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true; // 是微信端
				} else {
					return false;
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let cnt = {
							phone: this.ruleForm.accountNumber, // String 手机
							pwd: this.ruleForm.pass, // String <选填> 密码
						};
						// unionId存在
						if ((sessionStorage.getItem('unionId') != null && sessionStorage.getItem('unionId') != '')) {
							cnt.openId = sessionStorage.getItem('openId')
							cnt.unionId = sessionStorage.getItem('unionId')
							cnt.nickName = sessionStorage.getItem('nickName')
							cnt.headImg = sessionStorage.getItem('headImg')
						}
						this.$api.login(cnt, res => {
							if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
								this.$message.success('登录成功')
								localStorage.setItem("user", res.data.c);
								let info = JSON.parse(localStorage.getItem("user"))
								this.$emit("loginOk",true);
							} else {
								// 接口返回失败数据
								this.$message.error(res.data.rm);
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			retrun: function() {
				this.$router.push({
					path: '/'
				})
			},
			register: function() {
				if (this.isWeiXin()) {
					this.$router.push({
						path: '/register',
						query: {
							unionId: this.$route.query.unionId,
							openId: this.$route.query.openId,
							nickName: this.$route.query.nickName,
							headImg: this.$route.query.headImg,

						}
					})
				} else {
					this.$router.push({
						path: '/register',
						query: {
							team: this.isteamR
						}

					})
				}
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style scoped>
	.signin {
		width: 430px;
		/* background-color: darkgoldenrod; */
		margin: 80px auto;
	}

	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}

	.retrun {
		margin-top: 10px;
		cursor: pointer;
		margin-left: 10px;
		color: #4fb3ff;
	}

	.retrun:hover {
		color: #49bee5;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		color: #333;
		text-align: center;
	}

	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.signinbtn {
		background-image: linear-gradient(to right, #5173ff, #3dbbff);
	}

	.zucbtn {
		background-image: linear-gradient(to right, #ff8251, #ffb33d);
		border: none;
	}

	.lunbo2 {
		display: none;
	}

	.isshow {
		visibility: hidden;
	}

	@media (max-width: 980px) {
		.head {
			width: 100%;
		}
	}

	@media (max-width: 680px) {
		.signin {
			width: 70%;
			margin: 0 auto;
		}
	}

	@media (max-width:500px) {
		.lunbo1 {
			display: none;
		}

		.lunbo2 {
			display: block;
		}

		.isshow {
			visibility: visible;
		}

		.head {
			padding-right: 0;
		}

	}
</style>
